(() => {
  let nativeBusy = false;
  const update = busy => {
    document.body.toggleAttribute('data-mys-checkout-busy', busy);
    document.querySelectorAll('[data-mys-checkout-button]').forEach(button => {
      const label = button.querySelector('[data-mys-checkout-label]');
      if (label && !button.dataset.mysCheckoutOriginal) button.dataset.mysCheckoutOriginal = label.textContent;
      button.setAttribute('aria-busy', String(busy));
      if (busy) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
      if (label) label.textContent = busy ? button.dataset.mysCheckoutBusy : button.dataset.mysCheckoutOriginal;
    });
  };
  document.addEventListener('submit', event => {
    if (event.defaultPrevented || !(event.target instanceof HTMLFormElement)) return;
    const button = event.submitter;
    if (button?.name !== 'checkout' || !button.hasAttribute('data-mys-checkout-button')) return;
    if (nativeBusy) { event.preventDefault(); return; }
    nativeBusy = true;
    update(true);
  });
  document.addEventListener('click', event => {
    if (nativeBusy && event.target.closest?.('[data-mys-checkout-button]')) event.preventDefault();
  }, { capture: true });
  document.addEventListener('mys:checkout-state', event => {
    document.body.toggleAttribute('data-mys-checkout-busy', event.detail?.busy === true);
  });
  window.addEventListener('pageshow', () => { if (nativeBusy) { nativeBusy = false; update(false); } });
})();
